






































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Ththreshold from "../../../store/entities/ththreshold";
import { number } from "echarts";
@Component
export default class EditThthreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  ththreshold: Ththreshold = new Ththreshold();
  save() {
    (this.$refs.ththresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "ththreshold/update",
          data: this.ththreshold,
        });
        (this.$refs.ththresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.ththresholdForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.ththreshold = Util.extend(true, {}, this.$store.state.ththreshold.editThthreshold);
    }
  }
  ththresholdRule = {
    tName: [{required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    maxtemp: [{required: true, message: "请填写最大温度",type:"number", trigger: "blur" }],
    mintemp: [{required: true, message: "请填写最小温度",type:"number", trigger: "blur" }],
    maxhumi: [{required: true, message: "请填写最大湿度",type:"number", trigger: "blur" }],
    minhumi: [{required: true, message: "请填写最小湿度",type:"number", trigger: "blur" }],
  };
}
